<!--
 * @Author: zhonghao
 * @Date: 2023-09-12 10:37:24
-->
<template>
  <div class="live-list">
    <div class="flex-title">
      <div
        class="title-txt"
        :class="itemtxt === 0 ? 'cur' : ''"
        @click="handleClickItems(0)"
      >
        直播预告
        <img
          src="../../assets/images/home/underline@2x.png"
          v-if="itemtxt === 0"
          class="cur-icon"
          alt=""
        />
      </div>
      <div
        class="title-txt"
        :class="itemtxt === 1 ? 'cur' : ''"
        @click="handleClickItems(1)"
      >
        直播回放
        <img
          src="../../assets/images/home/underline@2x.png"
          v-if="itemtxt === 1"
          class="cur-icon"
          alt=""
        />
      </div>
    </div>
    <van-list
      v-model="state.loading"
      :finished="state && state.finished"
      finished-text="没有更多了"
      @load="onLoad"
      class="list"
      v-if="list.length > 0"
      offset="10"
    >
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="handleClick(item)"
        v-track="{ functionName: '直播-直播列表' }"
      >
        <img :src="item && item.icon" class="item-cover" v-if="itemtxt === 0" alt="" />
        <img
          :src="item && item.coverMaterialUrl"
          class="item-cover"
          v-else-if="itemtxt === 1"
          alt=""
        />
        <div class="item-info">
          <div class="txt1" v-if="itemtxt === 0">{{ item && item.title }}</div>
          <div class="txt1" v-if="itemtxt === 1">{{ item && item.name }}</div>
          <div class="txt2" v-if="itemtxt === 0">
            <div class="txt2-time">
              {{ $moment(parseInt(item.start)).format("MM月DD日 HH:mm") }} ~
              {{ $moment(parseInt(item.end)).format("HH:mm") }}
            </div>
            <div
              class="txt2-btn"
              v-if="`${item.ismake}` === '1'"
              @click.stop="handleClickMake(item)"
            >
              已预约
            </div>
            <div
              class="txt2-btn cur"
              v-else
              @click.stop="handleClickMake(item)"
            >
              预约
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="none" v-else-if="isNone && list.length <= 0">
      <img src="../../assets/images/home/live_none.png" class="none-img" alt="" />
      <div class="none-txt">暂无{{ itemtxt === 0 ? "直播" : "直播回放" }}</div>
    </div>
    <barComponents></barComponents>
  </div>
</template>
<script>
import { getLiveList, liveMake } from '@/api/api'
import { getDatabaseCoursesList } from '../../api/database'
import barComponents from '../../components/barComponents.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    barComponents,
  },
  data() {
    return {
      list: [],
      itemtxt: 0,
      isNone: false,
      load: false,
      // 筛选项分页
      state: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '已经到底了',
      },
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.handleFun()
    })
  },
  methods: {
    handleFun() {
      getLiveList({
        openId: this.userInfo.iepOpenId,
      }).then((res) => {
        this.state.finished = true
        if (res.data.list && res.data.list.length > 0) {
          this.list = res.data.list.map((item) => {
            item.startTxt = this.$moment(parseInt(item.start)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
            return item
          })
          if (this.itemtxt === 1) {
            this.list = []
          }
          if (this.list.length <= 0) {
            this.isNone = true
          }
        } else {
          this.isNone = true
        }
        console.log(this.list, '=--')
      })
    },
    handleClickItems(index) {
      this.itemtxt = index
      this.list = []
      if (this.itemtxt === 0) {
        this.handleFun()
      } else {
        this.state.pageNo = 1
        this.state.finished = false
        this.onLoad()
      }
    },
    handleClickMake(item) {
      let params = {
        userId: this.userInfo.id,
        liveId: item.id,
        type: `${item.ismake}` === '0' ? 1 : 0,
      }
      liveMake(params).then((res) => {
        if (res && res.code === 111) {
          return
        }
        this.$toast(`${item.ismake}` === '0' ? '预约成功' : '取消预约成功')
        this.handleFun()
      })
    },
    handleClick(item) {
      if (this.itemtxt === 1) {
        this.$router.push({
          path: 'courserDetails',
          query: {
            courseId: item.id,
            journeyId: item.journeyId,
          },
        })
      } else {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.id}&entrance=100&channel=100`)
        this.$router.push({
          path: 'liveDetails',
          query: {
            liveId: item.id,
            entrance: 100,
            channel: 100,
          },
        })
      }
    },
    onLoad() {
      if (this.itemtxt !== 1) return
      if (this.load) {
        return
      }
      this.load = true
      this.state.loading = true
      this.$toast.loading({ message: '加载中...' })
      let params = {
        pageNum: this.state.pageNo,
        pageSize: this.state.pageSize,
        dataValue: '',
        journeyId: '',
        stageId: '',
        description: '直播回放',
      }
      getDatabaseCoursesList(params)
        .then((res) => {
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.state.finished = true
              return false
            }
            if (res.data.list.length < this.state.pageSize) {
              this.state.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            console.log(this.list)
            this.state.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
        .finally(() => {
          this.load = false
          this.state.loading = false
          this.$toast.clear()
        })
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.live-list {
  min-height: 100vh;
  width: 100vw;
  background-color: #f7f9fb;
  padding-bottom: 60px;
  box-sizing: border-box;

  .flex-title {
    display: flex;
    align-items: center;
    background-color: #fff;

    .title-txt {
      flex: 1;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      color: #6a7481;

      .cur-icon {
        width: 23px;
        height: 10px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      &.cur {
        color: #000000;
        position: relative;
      }
    }
  }

  .list {
    padding: 0 16px;
    box-sizing: border-box;

    .item {
      margin-top: 8px;
      border-radius: 12px;
      background-color: #fff;
      padding: 11px 13px 16px 10px;
      box-sizing: border-box;
      display: flex;

      .item-cover {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        display: block;
        margin-right: 8px;
        min-width: 80px;
        max-width: 80px;
        object-fit: cover;
      }

      .item-info {
        flex: 1;
        .txt1 {
          line-height: 20px;
          font-size: 14px;
          color: #000000;
          margin-bottom: 17px;
          height: 40px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .txt2 {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .txt2-time {
            font-size: 13px;
            color: #b1b1b1;
          }

          .txt2-btn {
            width: 56px;
            height: 24px;
            text-align: center;
            line-height: 26px;
            border: 1px solid #EB1700;
            border-radius: 100px;
            font-size: 14px;
            color: #EB1700;

            &.cur {
              background-color: #EB1700;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .none {
    display: block;

    .none-img {
      width: 185px;
      margin-top: 122px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .none-txt {
      text-align: center;
      font-size: 12px;
      color: #949ba5;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/liveList.vue